import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { slug } from '@magalu/mixer-utils';
var categories = [{
  id: 3,
  name: 'GE12'
}, {
  id: 4,
  name: 'GE24'
}, {
  id: 9,
  name: 'GE36'
}, {
  id: 7,
  name: 'RF12'
}, {
  id: 8,
  name: 'RF24'
}, {
  id: 5,
  name: 'TC12'
}, {
  id: 6,
  name: 'TC24'
}, {
  id: 10,
  name: 'TC36'
}];
var parseEcommerce = function parseEcommerce(value) {
  var _value$product, _value$product$financ;
  var validServiceIds = (value == null ? void 0 : value.services) || [];
  var fullPrice = 0;
  var filteredOptions = value.adaptedServices.flatMap(function (item) {
    return item.period.options.filter(function (option) {
      return option.checked;
    });
  });
  var items = (value == null ? void 0 : (_value$product = value.product) == null ? void 0 : (_value$product$financ = _value$product.financialServices) == null ? void 0 : _value$product$financ.flatMap(function (itemService) {
    return itemService.offers.filter(function (offer) {
      return validServiceIds.includes(offer.id);
    }).map(function (offer) {
      var _categories$find, _value$product2;
      var nameFound = ((_categories$find = categories.find(function (cat) {
        return cat.id === offer.id;
      })) == null ? void 0 : _categories$find.name) || '';
      fullPrice += Number(offer.price) || 0;
      var matched = filteredOptions.find(function (opt) {
        return opt.value === offer.id;
      });
      return {
        dimension87: "tag:".concat((matched == null ? void 0 : matched.recommended) ? 'recomendado' : 'sem-tag'),
        item_category: "servicos/".concat(slug(offer.description || '')),
        item_id: offer.id,
        item_name: nameFound,
        item_variant: value == null ? void 0 : (_value$product2 = value.product) == null ? void 0 : _value$product2.id,
        price: offer.price,
        quantity: 1
      };
    });
  })) || [];
  return {
    fullPrice: fullPrice,
    items: items
  };
};
var addToCartWarranty = function addToCartWarranty(_ref) {
  var _window, _window$crypto;
  var value = _ref.value;
  var eventId = (_window = window) == null ? void 0 : (_window$crypto = _window.crypto) == null ? void 0 : _window$crypto.randomUUID == null ? void 0 : _window$crypto.randomUUID();
  var userId = (value == null ? void 0 : value.customerId) || null;
  var _parseEcommerce = parseEcommerce(value),
    fullPrice = _parseEcommerce.fullPrice,
    items = _parseEcommerce.items;
  return {
    currency: 'BRL',
    event: 'add_to_cart',
    eventId: eventId,
    eventLabel: 'seguro:incluir-protecao',
    idUsuario: userId || null,
    items: _toConsumableArray(items),
    loginAtivo: userId ? 'logado' : 'nao-logado',
    screenName: 'seguro',
    value: fullPrice
  };
};
export default addToCartWarranty;